/* src/app/main/pages/home-page/home-page.component.css */
button.scroll-btn {
  position: fixed;
  top: 100px;
  right: 10px;
  font-size: 36px;
  text-align: center;
  border-radius: 5px;
  outline: none;
  border: none;
  color: #E8882D;
  background-color: transparent;
}
/*# sourceMappingURL=home-page.component.css.map */
